import * as XLSX from 'xlsx';

import { inferColumnMapping } from '@/features/import/headerMap';
import { normalizeRows, normalizeRowsDetailed, type NormalizationResult } from '@/features/import/normalizer';
import type { RawRow, WorkbookImport } from '@/features/import/types';
import type { ColumnMapping, LocationAliasMap } from '@/features/network/models';

export async function parseWorkbookFile(file: File): Promise<WorkbookImport> {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: 'array' });

  const rowsBySheet: Record<string, RawRow[]> = {};
  const headersBySheet: Record<string, string[]> = {};
  const inferredMappingsBySheet: Record<string, ColumnMapping> = {};

  for (const sheetName of workbook.SheetNames) {
    const rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
      defval: '',
      raw: false,
    }) as RawRow[];

    const headers = Array.from(new Set(rows.flatMap((row) => Object.keys(row))));
    rowsBySheet[sheetName] = rows;
    headersBySheet[sheetName] = headers;
    inferredMappingsBySheet[sheetName] = inferColumnMapping(headers);
  }

  return {
    fileName: file.name,
    sheetNames: workbook.SheetNames,
    rowsBySheet,
    headersBySheet,
    inferredMappingsBySheet,
  };
}

export { normalizeRows, normalizeRowsDetailed };
export type { NormalizationResult };

export function normalizeRowsForGraph(rows: RawRow[], mapping: ColumnMapping, aliases: LocationAliasMap = {}) {
  return normalizeRows(rows, mapping, aliases);
}

export function normalizeRowsWithAudit(rows: RawRow[], mapping: ColumnMapping, aliases: LocationAliasMap = {}): NormalizationResult {
  return normalizeRowsDetailed(rows, mapping, aliases);
}
